import React, { useContext, useEffect, useState } from "react";
import { Box, Modal, TextField, Grid, Autocomplete } from "@mui/material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import AuthContext from "../../store/AuthContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};
const EditAssetModal = ({ open, onClose, data, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    // cost: "",
    category: "",
    assigned_to: "",
  });
  const [developers, setDevelopers] = useState([]);
  const [developerId, setDeveloperId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        description: data.description || "",
        // cost: data.cost || "",
        category: data.category || "",
        assigned_to: data.assigned_id || "",
      });
      setDeveloperId(data.assigned_to || null);
    }
  }, [data]);

  const fetchDevelopers = async () => {
    if (developers.length) return;

    setLoading(true);
    try {
      const res = await postJsonData(
        `${ApiEndpoints.GET_USERS_NAME}?role=developer`,
        ""
      );
      if (res?.data) {
        setDevelopers(res.data);
      }
    } catch (err) {
      apiErrorToast("Failed to load developers");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    if (!formData.name) {
      apiErrorToast("Asset name is required");
      return;
    }
    setIsSubmitting(true);

    const payload = { ...formData, id: data.id, assigned_to: developerId };

    postJsonData(
      ApiEndpoints.UPDATE_ASSET,
      payload,
      setIsSubmitting,
      (response) => {
        if (response) {
          okSuccessToast(response.data.message);
          onSuccess(); // Refresh data
          onClose();
        } else {
          apiErrorToast(response.message || "Asset update failed.");
        }
      },
      (error) => {
        apiErrorToast(error.message || "Error updating asset.");
      }
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <ModalHeader
          title="Edit Asset"
          subtitle="Update asset information below."
          handleClose={onClose}
        />

        <Box sx={{ px: 4, pb: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Asset Name"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </Grid>
            {user?.role === "Admin" && (
              <Grid item xs={6}>
                <TextField
                  label="Cost"
                  fullWidth
                  name="cost"
                  value={formData.cost}
                  onChange={handleChange}
                />
              </Grid>
            )}

            <Grid item xs={6}>
              <TextField
                label="Category"
                fullWidth
                name="category"
                value={formData.category}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                options={developers}
                loading={loading}
                onOpen={fetchDevelopers} // API call when opened
                getOptionLabel={(option) => option.name || ""}
                value={developers.find((dev) => dev.id === developerId) || null}
                onChange={(event, newValue) => {
                  setDeveloperId(newValue ? newValue.id : null);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Assign Developer"
                    required
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? "Loading..." : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ px: 4, pb: 3 }}>
          <ModalFooter
            request={isSubmitting}
            btn="Update"
            onClick={handleSubmit}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default EditAssetModal;
